
import {
     Card, 
     //CardHeader, 
     Stack,
     CardContent,
     Avatar,
     Divider,
     Box,
     Grid,
     Typography,
     IconButton,
     Tooltip,
     //Button
} from '@mui/material';

import { useTheme } from '@mui/material/styles';
import { Icon } from '@iconify/react';
import React from 'react';

//import bxsChat from '@iconify/icons-bx/bxs-chat'; 
//TODO: colocar icon botao chat ao lado do nome do utente

import emailSolid from '@iconify/icons-clarity/email-solid';
import bxsPhoneCall from '@iconify/icons-bx/bxs-phone-call';
import bxsIdCard from '@iconify/icons-bx/bxs-id-card';
import bxsCreditCardFront from '@iconify/icons-bx/bxs-credit-card-front';
import EditIcon from '@mui/icons-material/Edit';

//import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
//import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

//import dadosSessoes from './DadosSessoes';

export default function InfoUtente() {
    const theme = useTheme();

    const getIcon = (name) => <Icon style={{marginRight:5}}icon={name} width={22} height={22} />;

    const user = {
        avatar: '/static/mock-images/avatars/avatar_1.jpg',
        name: 'João Magalhães',
        age: 28,
        altura: 182,
        peso: 92,
        email: 'joaom@uc.pt',
        telemovel: '914 322 844',
        cc: '142 933 922',
        nrUtente: '443 765 899',
        diagnostico: 'Lombalgia',
        medico: 'José Agostinho',
        fisioterapeuta: 'João Paiva'
    };

    return (
        <Card>
        <CardContent style={{
                             display: 'flex', alignItems: 'center',
                             justifyContent: 'center'}}>
            
            
            <Stack direction = "row" alignItems="center">
                <Avatar alt={user.name} src={user.avatar}  sx={{marginRight: 5, width: 150, height: 150,display: 'flex', alignItems: 'center',
                             justifyContent: 'center'}} variant="outlined"/>
            </Stack>
                    
                <Grid container spacing={0.5}>
                    <Grid item xs={12} md={12} lg={12}>
                        <Typography variant="h4" >
                        {user.name} 
                        </Typography>
                        <Divider style={{marginBottom: theme.spacing(1)}} />
                    </Grid>
                    
                    <Grid item xs={12} md={5} lg={5}>
                        <Box>
                            <Typography style={{
                                width: 60, marginRight: 60, display: 'inline-block'}}  color="textSecondary" variant="body1" component="span">
                            Diagnóstico
                            </Typography>
                            <Typography color={theme.palette.primary.main} variant="body1" component="span">
                            {user.diagnostico} 
                            </Typography>
                        </Box>
                        
                        <Box>
                            <Stack direction = "column" alignItems="left" >
                                <Stack direction="row" alignItems="center">
                                    <Typography color="textSecondary" variant="body1" component="span">
                                    História Clínica
                                    </Typography>

                                    <Tooltip color='primary' title="Editar">
                                        <IconButton size="small">
                                            <EditIcon/>
                                        </IconButton>
                                    </Tooltip>
                                </Stack>
                               
                                <Typography color={theme.palette.primary.main} variant="body2" component="span">
                                Teve três cirurgias ao joelho direito. Três lesões na lombar em 2010. É um crónico desportista lesionado.
                                </Typography>
                            </Stack>
                        </Box>

                        <Box>
                            <Typography style={{
                                width: 60, marginRight: 60, display: 'inline-block'}}  color="textSecondary" variant="body1" component="span">
                            Médico
                            </Typography>
                            <Typography color={theme.palette.primary.main} variant="body1" component="span">
                            {user.medico} 
                            </Typography>
                        </Box>
                    </Grid>
                    
                    
                    <Grid item xs={12} md={3} lg={3}>
                        <Box>
                            <Typography style={{
                                width: 30, marginRight: 30, display: 'inline-block'}} 
                                color="textSecondary"  variant="body1" component="span">
                            Idade
                            </Typography>
                            <Typography color={theme.palette.primary.main} variant="body1" component="span">
                                {user.age} anos
                            </Typography>
                        </Box>
                        
                        <Box >
                            <Typography style={{
                                width: 30,marginRight: 30, display: 'inline-block'}} color="textSecondary" variant="body1" component="span">
                            Altura
                            </Typography>
                            <Typography color={theme.palette.primary.main} variant="body1" component="span">
                            {user.altura} cm
                            </Typography>
                        </Box>

                        <Box>
                            <Typography style={{
                                width: 30, marginRight: 30,  display: 'inline-block'}}  color="textSecondary" variant="body1" component="span">
                            Peso
                            </Typography>
                            <Typography color={theme.palette.primary.main} variant="body1" component="span">
                            {user.peso} kg
                            </Typography>
                        </Box>
                        
                        <Box>
                            <Typography style={{
                                width: 30,marginRight: 30,  display: 'inline-block'}}  color="textSecondary" variant="body1" component="span">
                            IMC
                            </Typography>
                            <Typography color={theme.palette.primary.main} variant="body1" component="span">
                            {parseFloat(user.peso/((user.altura/100)*(user.altura/100))).toFixed(2)} kg/m²
                            </Typography>
                        </Box>
                    </Grid>
                    
                    <Grid item xs={12} md={4} lg={4}>
                        
                        <Box style={{
                            display: 'flex', alignItems: 'center',
                            flexWrap: 'wrap'}}>
                            <Typography style={{
                                width: 110,marginRight: 30, display: 'flex', alignItems: 'center',
                                flexWrap: 'wrap'}}  color="textSecondary" variant="body1" component="span">
                            {getIcon(emailSolid)} E-mail
                            </Typography>
                            <Typography color={theme.palette.primary.main} variant="body1" component="span">
                            {user.email} 
                            </Typography>
                        </Box>

                        <Box style={{
                            display: 'flex', alignItems: 'center',
                            flexWrap: 'wrap'}}>
                            <Typography style={{
                                width: 110,marginRight: 30, display: 'flex', alignItems: 'center',
                                flexWrap: 'wrap'}}  color="textSecondary" variant="body1" component="span">
                            {getIcon(bxsPhoneCall)} Telemóvel
                            </Typography> 
                            <Typography color={theme.palette.primary.main} variant="body1" component="span">
                            {user.telemovel} 
                            </Typography>
                        </Box>

                        <Box style={{
                            display: 'flex', alignItems: 'center',
                            flexWrap: 'wrap'}}>
                            <Typography style={{
                                width: 110,marginRight: 30, display: 'flex', alignItems: 'center',
                                flexWrap: 'wrap'}}  color="textSecondary" variant="body1" component="span">
                            {getIcon(bxsIdCard)} CC
                            </Typography>
                            <Typography color={theme.palette.primary.main} variant="body1" component="span">
                            {user.cc} 
                            </Typography>
                        </Box>

                        <Box style={{
                            display: 'flex', alignItems: 'center',
                            flexWrap: 'wrap'}}>
                            <Typography style={{
                                width: 110,marginRight: 30, display: 'flex', alignItems: 'center',
                                flexWrap: 'wrap'}}  color="textSecondary" variant="body1" component="span">
                            {getIcon(bxsCreditCardFront)}N.º Utente
                            </Typography>
                            <Typography color={theme.palette.primary.main} variant="body1" component="span">
                            {user.nrUtente} 
                            </Typography>
                            

                        </Box>
                        
                    </Grid>
                    
                    {/*
                    <Grid item xs={12} md={12} lg={12}>
                        <Box paddingTop={1}>
                                <Typography color={theme.palette.primary.main} variant="h6" component="span">
                                Sessões Disponíveis
                                </Typography>
                            </Box>

                            <Box>
                                {
                                    dadosSessoes.map((item, index) => {
                                        return(
                                            <Button key={index} sx={{cursor: "auto"}}size="small" variant='outlined' >
                                                <Typography color="textSecondary" variant="body2">{item.title}</Typography>
                                            </Button>
                                            )
                                    })
                                }
                            </Box>
                    </Grid>
                    */}
                </Grid>

        </CardContent>
        </Card>
    );
}


